import React from 'react';

import { IconProps } from './types';

const InefficientIcon: React.FC<IconProps> = props => {
  const { width = '18', height = '18', fillColor = 'var(--blue-base)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_151_20249"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_151_20249)">
        <path
          d="M13.3329 15V13.3333H15.4996L11.1663 9.04167L7.83293 12.375L1.66626 6.16667L2.83293 5L7.83293 10L11.1663 6.66667L16.6663 12.1667V10H18.3329V15H13.3329Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default InefficientIcon;
